import * as Yup from "yup";
import { formattedPhoneNumberLength } from "../../utils/phoneNumberSupport";
import moment from "moment";
import { validation, conditionalValidation } from "../../utils/constants";

const SUPPORTED_FORMATS = ["image/jpg", "image/png", "image/jpeg", "image/gif"];
const FILE_SIZE = 160 * 1024;
export const FormikObj = (practitioner) => ({
    initialValues: {
        first_name: "",
        last_name: "",
        date_of_birth: "",
        phone_number: "",
        ext: "",
        address: "",
        city: "",
        country: "",
        region: "",
        postalCode: "",
        file: null,
        profileImage: null,
        id: "",
        designation:"",
        qualification:"",
        license:"",
        home_phone_number:""

    },
    validationSchema: Yup.object({
        first_name: conditionalValidation(
            Yup.string()
                .max(30, "Must be 30 characters or less")
                .matches(/^$|^\S+.*/, "Only blankspaces is not valid."),
            {
                validation,
                label:"First Name",
                mandatory: true
            }),
        last_name: conditionalValidation(
            Yup.string()
                .max(30, "Must be 30 characters or less")
                .matches(/^$|^\S+.*/, "Only blankspaces is not valid."),
            {
                validation,
                label: "Last Name",
                mandatory: true
            }),
        date_of_birth: conditionalValidation(
            Yup.string().when("type", (type, schema) =>{
                if (practitioner === true) {
                    return schema
                        .test('min-age', 'Age cannot be below 16 years. Please provide a valid age.', function (value) {
                        const currentDate = moment();
                        const birthDate = moment(value, /* 'YYYY-MM-DD' */  'MM-DD-YYYY'); 
                        const age = moment.duration(currentDate.diff(birthDate)).years();
                        let minDate = moment().subtract(125, "years");
                        if (birthDate.isBefore(minDate)) {
                            return this.createError({
                            message: "Date of Birth cannot be more than 125 years ago.",
                            });
                        }
                        return age >= 16;
                        });
                }
                else {
                    return schema;
                }
            }),
            {
                validation,
                label: "Date of Birth",
                mandatory: true
            }),
        phone_number: conditionalValidation(
          Yup.string()
            .matches(
              /^(?:\+?1[-. ]?)?\(?\d{3}\)?[-. ]?\d{3}[-. ]?\d{4}$/,
              "Enter Valid Work Phone Number."
            )
            .test(
              "is-valid-or-empty-placeholder",
              "Enter Valid Work Phone Number.",
              (value) => {
                if (value && value.trim() === "(___) ___-____") return true; // allow placeholder
                  return /^(?:\+?1[-. ]?)?\(?\d{3}\)?[-. ]?\d{3}[-. ]?\d{4}$/.test(value);
                }
            ),
          {
            validation,
            label: "Work Phone Number"
          }),
        home_phone_number: conditionalValidation(
          Yup.string()
            .matches(
              /^(?:\+?1[-. ]?)?\(?\d{3}\)?[-. ]?\d{3}[-. ]?\d{4}$/,
              "Enter Valid Home Phone Number."
            )
            .test(
              "is-valid-or-empty-placeholder",
              "Enter Valid Home Phone Number.",
              (value) => {
                if (value && value.trim() === "(___) ___-____") return true; // allow placeholder
                  return /^(?:\+?1[-. ]?)?\(?\d{3}\)?[-. ]?\d{3}[-. ]?\d{4}$/.test(value);
                }
            ),
          {
            validation,
            label: "Home Phone Number"
          }),
        // TODO Multilingual Support
        ext: conditionalValidation(
            Yup.string().matches(/^\d{0,4}$/, "Must be 4 digits or less."),
            { validation }
        ),

        address: conditionalValidation(
            Yup.string()
                .matches(/^$|^\S+.*/, "Only blankspaces is not valid."),
            {
                validation,
                mandatory: true,
                label: "Address"
            }),
        city: conditionalValidation(
            Yup.string()
                .matches(/^$|^\S+.*/, "Only blankspaces is not valid."),
            {
                validation,
                mandatory: true,
                label: "City"
            }),
        postalCode: Yup.string().when(["type", "country"], (type, country, schema) =>
          conditionalValidation(
            country === "US"
              ? Yup.number()
                .typeError("Zip code must be a number")
              : Yup.string()
                .matches(
                  /^[A-Za-z]\d[A-Za-z] [0-9][A-Za-z]\d$/,
                  "Postal code must be in A1A 1A1 format."
                ),
              {
                validation,
                mandatory: true,
                label: (country === "US")? "Zip code":"Postal code"})
        ),
        country: conditionalValidation(
            Yup.string()
            .matches(/^$|^\S+.*/, "Only blankspaces is not valid."),
            {
                validation,
                mandatory: true,
                label: "Country"}),

        region: conditionalValidation(
            Yup.string()
            .matches(/^$|^\S+.*/, "Only blankspaces is not valid."),
            {
                validation,
                mandatory: true}),

        qualification: conditionalValidation(
            Yup.string()
                .max(50, "Must be 50 characters or less"),
            {
                validation,
                label: "Qualification"
            }),

        license: conditionalValidation(
            Yup.string()
                .max(20, "Must be 20 characters or less"),
            {
                validation,
                label: "License"
            }),


        file: Yup.mixed()
            .nullable()
            .notRequired()
            .test("FILE_SIZE", "Uploaded file is too big.", (value) => !value || (value && value.size <= FILE_SIZE))
            .test("FILE_FORMAT", "Uploaded file has unsupported format.", (value) => !value || (value && SUPPORTED_FORMATS.includes(value.type))),
        profileImage: Yup.mixed()
            .nullable()
            .notRequired()
            .test("FILE_SIZE", "Uploaded file is too big.", (value) => !value || (value && value.size <= FILE_SIZE))
            .test("FILE_FORMAT", "Uploaded file has unsupported format.", (value) => !value || (value && SUPPORTED_FORMATS.includes(value.type))),
    }),
})